import i18n from 'i18next';

function DataPrivacyContent() {
    if (i18n.language === "CHT") {
        return (
            <div>
                <p>
                    本聲明乃凱基(香港) (定義如下) 根據香港法例第486章《個人資料(私隱)條例》(「私隱條例」)作出，目的是向資料當事人(定義如下)資料當事人闡明收集個人資料的原因、用途和查詢個人資料記錄的途徑。
                </p>
                <p>
                    1. 資料當事人或其他有關人士在申請開立戶口或延續戶口，建立或延續交易或信貸設施或在凱基(香港)提供金融、證券、商品、衍生產品、期貨、期權、投資、信貸、保險、強積金／職業退休計劃、財富管理、資產管理、投資者教育活動／遊戲及相關顧問或其他服務、產品及設施時，須要不時向凱基(香港)提供資料。
                </p>
                <p>
                    2. 若資料當事人未能向凱基(香港)提供有關資料，可能會導致凱基(香港)無法開立或延續戶口或建立或延續交易或信貸設施或提供上文第 1 條條款所述的服務、產品或設施。
                </p>
                <p>
                    3. 在資料當事人或其他有關人士與凱基(香港)的正常業務往來或其他交易過程中，凱基(香港)亦會收集資料當事人的資料。在使用凱基(香港)網站時，資料當事人的資料 (包括線上識別碼) 及其流覽活動的資訊將被通過使用 cookie 和其他技術進行收集和跟蹤。
                </p>
                <p>
                    4. 資料當事人的資料可能會(無論在香港或香港以外) 被使用及處理，以作下列用途：
                </p>
                <p>
                    (i) 為資料當事人提供服務及設施之日常運作；
                </p>
                <p>
                    (ii) 作信貸檢查；
                </p>
                <p>
                    (iii) 協助其他金融機構作信貸檢查；
                </p>
                <p>
                    (iv) 確保資料當事人的信用維持良好；
                </p>
                <p>
                    (v) 為資料當事人設計上文第 1 條條款所述的服務、產品或設施，及進行調查、統計及資料分析，以加強及訂製該等服務、產品或設施；
                </p>
                <p>
                    (vi) 宣傳上文第 1 條條款所述的服務、產品及設施(有關凱基(香港)使用及提供個人資料作直接促銷用途的詳情載於下文第 6 條條款);
                </p>
                <p>
                    (vii) 確定凱基(香港)對資料當事人或資料當事人對凱基(香港)的債務；
                </p>
                <p>
                    (viii) 向資料當事人及為資料當事人提供擔保或抵押的人士追收欠款；
                </p>
                <p>
                    (ix) 根據凱基(香港)須遵守的法律及／或監管要求或法庭命令作出披露；
                </p>
                <p>
                    (x) 使凱基(香港)能夠遵守任何適用的法律、監管條例、規則、業界成規、法律義務，或在凱基(香港)受管轄的任何司法管轄區的交易所或監管、稅務、執法或政府機構的要求、請求、守則、指導或指引(例如：由香港稅務局發出有關實施自動交換財務帳戶資料的指引及美國《海外帳戶稅收合規法案》）;
                </p>
                <p>
                    (xi) 遵守為符合制裁、預防或偵測清洗黑錢、恐怖分子融資活動或其他非法活動的任何方案就於凱基證券集團內共用資料及資訊及／或資料及資訊的任何其他使用而制定的任何義務、要求、政策、程序、指引、措施或安排；及
                </p>
                <p>
                    (xii) 與上述任何項目有關的其他用途。
                </p>
                <p>
                    5. 凱基(香港)會把資料當事人的相關資料保密，但凱基(香港)可能會把該等資料提供給以下人士(無論在香港或香港以外)：
                </p>
                <p>
                    (i) 任何代理人、承辦商或向凱基(香港)提供與凱基(香港)的業務運作有關的行政、電訊、電腦、金融投資、執行交易服 務或現金、證券及／或合約結算或交收服務或其他服務的第三者服務供應人；
                </p>
                <p>
                    (ii) 任何對凱基(香港)有保密責任的人，包括但不限於已承諾把該等資料保密的任何凱基證券集團成員；
                </p>
                <p>
                    (iii) 任何與資料當事人已有或建議有交易往來的金融機構或交易商；
                </p>
                <p>
                    (iv) 任何信貸資料服務機構及於欠帳時給予收數公司；
                </p>
                <p>
                    (v) 任何凱基(香港)的實在或建議受讓人或參與人或附屬參與人或凱基(香港)對資料當事人權利的受讓人；
                </p>
                <p>
                    (vi) 任何為資料當事人的責任提供或建議提供擔保或抵押的人士；及
                </p>
                <p>
                    (vii) 在凱基(香港)必須符合對凱基(香港)具約束力的有關法律、法庭指令、監管條例、規則、法律義務、要求、請求、守則、指導、指引：在任何司法管轄區的交易所、實體、代理人或監管、稅務、執法或政府機構(無論是否為了履行其監管、監督及／或執法職能或其他目的)。通常在此情況下，凱基(香港)須要遵守保密責任而將不能通知資料當事人或在徵求資料當事人的同意後才向上述人士披露有關資料。
                </p>
                <p>
                    6. 在直接促銷中使用資料
                </p>
                <p>
                    凱基(香港)有意，但只會在獲得資料當事人的同意（包括表示不反對）下，把資料當事人的個人資料用作於直接促銷。就此，請注意：
                </p>
                <p>
                    (i) 資料當事人的個人資料，例如: 姓名、電話號碼、線上識別碼、電郵地址、通訊地址、帳戶號碼、產品及服務投資組合信息、交易模式及行為、風險狀況、財務背景及投資目標及經驗等，可能會被使用於直接促銷；
                </p>
                <p>
                    (ii) 以下類別的服務、產品、設施及推廣標的可用作促銷：
                </p>
                <p>
                    (1) 金融、證券、商品、衍生產品、期貨、期權、投資、信貸、保險、強積金／職業退休計劃、財富管理、資產管理、投資者教育活動／遊戲及相關顧問及／或其他服務、產品及設施；
                </p>
                <p>
                    (2) 獎賞、年資獎勵或優惠計劃及相關服務、產品及設施；
                </p>
                <p>
                    (3) 由任何凱基證券集團成員的商業夥伴所提供的服務、產品及設施(該等商業夥伴為提供任何上文第 6(ii)(1)條條款所述 的服務、產品及設施的供應商)；及
                </p>
                <p>
                    (4) 為慈善及／或非牟利目的而作出之捐款及捐贈；
                </p>
                <p>
                    (iii) 上述服務、產品、設施及推廣標的可由凱基(香港)及／或任何下述各方提供或（就捐款及捐贈而言）徵求：
                </p>
                <p>
                    (1) 任何凱基證券集團之成員；
                </p>
                <p>
                    (2) 第三方金融機構及提供任何上文第 6(ii)(1)條條款所述的服務、產品及設施的供應商；
                </p>
                <p>
                    (3) 第三方獎賞、年資獎勵、聯營或優惠計劃供應商；
                </p>
                <p>
                    (4) 任何凱基證券集團成員的商業夥伴(該等商業夥伴為提供任何上文第6(ii)(1)條條款所述的服務、產品及設施的供應商)；及
                </p>
                <p>
                    (5) 慈善或非牟利組織；
                </p>
                <p>
                    (iv) 凱基(香港) 有意，但只會在獲得資料當事人的書面同意（包括表示不反對）下，把上文第 6(i)條條款所述的個人資料提供予上文第 6(iii) 條條款所述的任何人士，以供該等人士在其直接促銷上文第 6(ii)條條款所述的服務、產品及設施時使用。凱基(香港)可能會為得益(不論是以收取費用、佣金、利益或其他形式)而向該等人士提供個人資料，以供該等人士用於直接促銷。
                </p>
                <p>
                    如資料當事人希望凱基(香港)停止使用資料當事人的個人資料及／或提供予其他人士作直接促銷用途，資料當事人可以書面方式通知凱基(香港)資料保護專員，其郵寄地址及傳真號碼載於下文第13條條款。此後，凱基(香港) 必須停止使用及／或提供資料當事人的個人資料作直接促銷用途，費用全免。
                </p>
                <p>
                    7. 資料當事人同意凱基(香港)可不時將資料當事人的個人資料轉至香港以外的地方作任何上述第1至第6條條款所述的任何用途。此外，個人資料可能會被轉移到歐洲經濟區 (歐洲區) 以外的國家，這些國家未有提供與歐洲區國家類似水平的保護。凱基(香港)將採取合理必要的步驟，以確保個人資料均得以足夠的保護，並按照本聲明所述的方式處理。
                </p>
                <p>
                    8. 如 閣下向凱基(香港)提供其他資料當事人的個人資料， 閣下承諾並表示 閣下已通知該等個人並取得其同意，凱基(香港)可按照本聲明收集、使用及處理其個人資料，並且在 閣下通知並獲取該等個人的同意時，閣下應完全遵守有關司法管轄區的所有適用個人資料保護法，包括但不限於私隱條例。 閣下同意在凱基(香港)提出要求時，將會及時向凱基(香港)提供有關同意的證據。
                </p>
                <p>
                    9. 在若干情況下資料當事人可能透過電子途徑（例如互聯網或話音錄音系統）向凱基(香港)提供個人資料。儘管凱基(香港)已竭盡所能以確保其系統的保安及可靠性，基於電訊傳送可能出現多種不可預計的情況，電子通訊的可靠性可能受到影響。有見及此，資料當事人在利用電子媒介傳送個人資料時應倍加留意。
                </p>
                <p>
                    10. 凱基(香港)只在有必要的期間内，為履行本聲明所述的使用個人資料的目的保留個人資料，如果根據任何法律或法規要求或在其他必要情況時，則保留個人資料的時間更長。
                </p>
                <p>
                    11. 在符合私隱條例之條款情況下，任何個人有權：
                </p>
                <p>
                    (i) 查核凱基(香港)是否持有資料當事人的資料及查閱有關的資料；
                </p>
                <p>
                    (ii) 要求凱基(香港)更正與該人士有關而不準確的資料；及
                </p>
                <p>
                    (iii) 查悉凱基(香港)對處理資料的政策與實務及凱基(香港)所持有的個人資料的種類。
                </p>
                <p>
                    如果個人來自歐洲聯盟 (歐盟) 成員國，除受某些局限及／或限制下，《通用數據保障條例》可能適用於該個人， 該個人有權依據《通用數據保障條例》:
                </p>
                <p>
                    (i) 要求取得和糾正，或刪除其個人資料；
                </p>
                <p>
                    (ii) 限制或反對處理其個人資料；
                </p>
                <p>
                    (iii) 具有資料便攜性的權利；
                </p>
                <p>
                    (iv) 在某些情況下，撤回他／她以前就處理其個人資料而給予的同意；及
                </p>
                <p>
                    (v) 就處理其個人資料向當地個人資料保護機構提出申訴。
                </p>
                <p>
                    12. 根據私隱條例的規定，凱基(香港)有權就處理任何查閱資料的要求收取合理費用。
                </p>
                <p>
                    13. 如欲要求停止使用資料當事人的個人資料作直接促銷用途，查詢或更正資料，查詢有關政策、慣例及資料的種類，行使上述任何權利或提出申訴，請向以下人士提出：
                </p>
                <p>
                    資料保護專員 凱基(香港)
                </p>
                <p>
                    香港灣仔港灣道十八號中環廣場四十一樓
                </p>
                <p>
                    電話：(852) 2878-6888 傳真：(852) 2878-4932
                </p>
                <p>
                    14. 凱基(香港)可對本聲明不時作出修改、修訂或補充。最新版本的聲明可於凱基(香港)之網站www.kgi.com.hk 取覽或以書面方式向凱基(香港)索取。本聲明(以及不時被修改、修訂或補充的聲明) 的內容適用於所有的資料當事人，並構成不時對有關資料當事人與凱基之間的關係具有約束力的條款及條件的一部分。
                </p>
                <p>
                    15. 在本聲明內，凱基證券亞洲有限公司、凱基資產管理有限公司、凱基金融亞洲有限公司、KGI Finance Limited、凱基期貨(香港)有限公司、凱基國際金融有限公司、凱基國際(香港)有限公司、凱基投資理財有限公司、凱基代理人(香港)有限公司及KGI Hong Kong Limited共同及個別稱為「凱基(香港)」，而凱基(香港)連同彼等各別的控股公司、附屬公司、相聯公司及關聯公司(無論在香港或香港以外)共同及個別稱為「凱基證券集團」。所有上文述及的「資料當事人」包括個人，而該個人為任何凱基(香港)公司預期的或現有的客戶或對手; 獲授權人、受益人、董事、股東、控制人、人員、員工; 凱基(香港)網站的訪客; 參與推廣活動、比賽、投資者教育活動或遊戲的人士; 及上文第5(vi) 條條款所述之人士。
                </p>
                <p>
                    如中英文版本有任何歧義，概以英文版本為準。
                </p>
                <p>
                    (2201)
                </p>
            </div>
        );
    }
    else if (i18n.language === "CHS") {
        return (
            <div>
                <p>
                    本声明乃凯基(香港) (定义如下) 根据香港法例第486章《个人资料(私隐)条例》(「私隐条例」)作出，目的是向资料当事人(定义如下)资料当事人阐明收集个人资料的原因、用途和查询个人资料记录的途径。
                </p>
                <p>
                    1. 资料当事人或其他有关人士在申请开立户口或延续户口，建立或延续交易或信贷设施或在凯基(香港)提供金融、證券、商品、衍生产品、期货、期权、投资、信贷、保险、强积金／职业退休计划、财富管理、资产管理、投资者教育活动／遊戏及相关顾问或其他服务、产品及设施时，须要不时向凯基(香港)提供资料。
                </p>
                <p>
                    2. 若资料当事人未能向凯基(香港)提供有关资料，可能会导致凯基(香港)无法开立或延续户口或建立或延续交易或信贷设施或提供上文第 1 条条款所述的服务、产品或设施。
                </p>
                <p>
                    3. 在资料当事人或其他有关人士与凯基(香港)的正常业务往来或其他交易过程中，凯基(香港)亦会收集资料当事人的资料。在使用凯基(香港)网站时，资料当事人的资料 (包括线上识别码) 及其流览活动的资讯将被通过使用 cookie 和其他技术进行收集和跟踪。
                </p>
                <p>
                    4. 资料当事人的资料可能会(无论在香港或香港以外) 被使用及处理，以作下列用途：
                </p>
                <p>
                    (i) 为资料当事人提供服务及设施之日常运作；
                </p>
                <p>
                    (ii) 作信贷检查；
                </p>
                <p>
                    (iii) 协助其他金融机构作信贷检查；
                </p>
                <p>
                    (iv) 确保资料当事人的信用维持良好；
                </p>
                <p>
                    (v) 为资料当事人设计上文第 1 条条款所述的服务、产品或设施，及进行调查、统计及资料分析，以加强及订製该等服务、产品或设施；
                </p>
                <p>
                    (vi) 宣传上文第 1 条条款所述的服务、产品及设施(有关凯基(香港)使用及提供个人资料作直接促销用途的详情载於下文第 6 条条款);
                </p>
                <p>
                    (vii) 确定凯基(香港)对资料当事人或资料当事人对凯基(香港)的债务；
                </p>
                <p>
                    (viii) 向资料当事人及为资料当事人提供担保或抵押的人士追收欠款；
                </p>
                <p>
                    (ix) 根据凯基(香港)须遵守的法律及／或监管要求或法庭命令作出披露；
                </p>
                <p>
                    (x) 使凯基(香港)能够遵守任何适用的法律、监管条例、规则、业界成规、法律义务，或在凯基(香港)受管辖的任何司法管辖区的交易所或监管、税务、执法或政府机构的要求、请求、守则、指导或指引(例如：由香港税务局发出有关实施自动交换财务帐户资料的指引及美国《海外帐户税收合规法案》）;
                </p>
                <p>
                    (xi) 遵守为符合制裁、预防或侦测清洗黑钱、恐怖分子融资活动或其他非法活动的任何方案就於凯基證券集团内共用资料及资讯及／或资料及资讯的任何其他使用而制定的任何义务、要求、政策、程序、指引、措施或安排；及
                </p>
                <p>
                    (xii) 与上述任何项目有关的其他用途。
                </p>
                <p>
                    5. 凯基(香港)会把资料当事人的相关资料保密，但凯基(香港)可能会把该等资料提供给以下人士(无论在香港或香港以外)：
                </p>
                <p>
                    (i) 任何代理人、承办商或向凯基(香港)提供与凯基(香港)的业务运作有关的行政、电讯、电脑、金融投资、执行交易服 务或现金、證券及／或合约结算或交收服务或其他服务的第叁者服务供应人；
                </p>
                <p>
                    (ii) 任何对凯基(香港)有保密责任的人，包括但不限於已承诺把该等资料保密的任何凯基證券集团成员；
                </p>
                <p>
                    (iii) 任何与资料当事人已有或建议有交易往来的金融机构或交易商；
                </p>
                <p>
                    (iv) 任何信贷资料服务机构及於欠帐时给予收数公司；
                </p>
                <p>
                    (v) 任何凯基(香港)的实在或建议受让人或参与人或附属参与人或凯基(香港)对资料当事人权利的受让人；
                </p>
                <p>
                    (vi) 任何为资料当事人的责任提供或建议提供担保或抵押的人士；及
                </p>
                <p>
                    (vii) 在凯基(香港)必须符合对凯基(香港)具约束力的有关法律、法庭指令、监管条例、规则、法律义务、要求、请求、守则、指导、指引：在任何司法管辖区的交易所、实体、代理人或监管、税务、执法或政府机构(无论是否为了履行其监管、监督及／或执法职能或其他目的)。通常在此情况下，凯基(香港)须要遵守保密责任而将不能通知资料当事人或在徵求资料当事人的同意後才向上述人士披露有关资料。
                </p>
                <p>
                    6. 在直接促销中使用资料
                </p>
                <p>
                    凯基(香港)有意，但只会在获得资料当事人的同意（包括表示不反对）下，把资料当事人的个人资料用作於直接促销。就此，请注意：
                </p>
                <p>
                    (i) 资料当事人的个人资料，例如: 姓名、电话号码、线上识别码、电邮地址、通讯地址、帐户号码、产品及服务投资组合信息、交易模式及行为、风险状况、财务背景及投资目标及经验等，可能会被使用於直接促销；
                </p>
                <p>
                    (ii) 以下类别的服务、产品、设施及推广标的可用作促销：
                </p>
                <p>
                    (1) 金融、證券、商品、衍生产品、期货、期权、投资、信贷、保险、强积金／职业退休计划、财富管理、资产管理、投资者教育活动／遊戏及相关顾问及／或其他服务、产品及设施；
                </p>
                <p>
                    (2) 奖赏、年资奖励或优惠计划及相关服务、产品及设施；
                </p>
                <p>
                    (3) 由任何凯基證券集团成员的商业夥伴所提供的服务、产品及设施(该等商业夥伴为提供任何上文第 6(ii)(1)条条款所述 的服务、产品及设施的供应商)；及
                </p>
                <p>
                    (4) 为慈善及／或非牟利目的而作出之捐款及捐赠；
                </p>
                <p>
                    (iii) 上述服务、产品、设施及推广标的可由凯基(香港)及／或任何下述各方提供或（就捐款及捐赠而言）徵求：
                </p>
                <p>
                    (1) 任何凯基證券集团之成员；
                </p>
                <p>
                    (2) 第叁方金融机构及提供任何上文第 6(ii)(1)条条款所述的服务、产品及设施的供应商；
                </p>
                <p>
                    (3) 第叁方奖赏、年资奖励、联营或优惠计划供应商；
                </p>
                <p>
                    (4) 任何凯基證券集团成员的商业夥伴(该等商业夥伴为提供任何上文第6(ii)(1)条条款所述的服务、产品及设施的供应商)；及
                </p>
                <p>
                    (5) 慈善或非牟利组织；
                </p>
                <p>
                    (iv) 凯基(香港) 有意，但只会在获得资料当事人的书面同意（包括表示不反对）下，把上文第 6(i)条条款所述的个人资料提供予上文第 6(iii) 条条款所述的任何人士，以供该等人士在其直接促销上文第 6(ii)条条款所述的服务、产品及设施时使用。凯基(香港)可能会为得益(不论是以收取费用、佣金、利益或其他形式)而向该等人士提供个人资料，以供该等人士用於直接促销。
                </p>
                <p>
                    如资料当事人希望凯基(香港)停止使用资料当事人的个人资料及／或提供予其他人士作直接促销用途，资料当事人可以书面方式通知凯基(香港)资料保护专员，其邮寄地址及传真号码载於下文第13条条款。此後，凯基(香港) 必须停止使用及／或提供资料当事人的个人资料作直接促销用途，费用全免。
                </p>
                <p>
                    7. 资料当事人同意凯基(香港)可不时将资料当事人的个人资料转至香港以外的地方作任何上述第1至第6条条款所述的任何用途。此外，个人资料可能会被转移到欧洲经济区 (欧洲区) 以外的国家，这些国家未有提供与欧洲区国家类似水平的保护。凯基(香港)将采取合理必要的步骤，以确保个人资料均得以足够的保护，并按照本声明所述的方式处理。
                </p>
                <p>
                    8. 如 阁下向凯基(香港)提供其他资料当事人的个人资料， 阁下承诺并表示 阁下已通知该等个人并取得其同意，凯基(香港)可按照本声明收集、使用及处理其个人资料，并且在 阁下通知并获取该等个人的同意时，阁下应完全遵守有关司法管辖区的所有适用个人资料保护法，包括但不限於私隐条例。 阁下同意在凯基(香港)提出要求时，将会及时向凯基(香港)提供有关同意的證据。
                </p>
                <p>
                    9. 在若干情况下资料当事人可能透过电子途径（例如互联网或话音录音系统）向凯基(香港)提供个人资料。儘管凯基(香港)已竭尽所能以确保其系统的保安及可靠性，基於电讯传送可能出现多种不可预计的情况，电子通讯的可靠性可能受到影响。有见及此，资料当事人在利用电子媒介传送个人资料时应倍加留意。
                </p>
                <p>
                    10. 凯基(香港)只在有必要的期间内，为履行本声明所述的使用个人资料的目的保留个人资料，如果根据任何法律或法规要求或在其他必要情况时，则保留个人资料的时间更长。
                </p>
                <p>
                    11. 在符合私隐条例之条款情况下，任何个人有权：
                </p>
                <p>
                    (i) 查核凯基(香港)是否持有资料当事人的资料及查阅有关的资料；
                </p>
                <p>
                    (ii) 要求凯基(香港)更正与该人士有关而不準确的资料；及
                </p>
                <p>
                    (iii) 查悉凯基(香港)对处理资料的政策与实务及凯基(香港)所持有的个人资料的种类。
                </p>
                <p>
                    如果个人来自欧洲联盟 (欧盟) 成员国，除受某些局限及／或限制下，《通用数据保障条例》可能适用於该个人， 该个人有权依据《通用数据保障条例》:
                </p>
                <p>
                    (i) 要求取得和纠正，或删除其个人资料；
                </p>
                <p>
                    (ii) 限制或反对处理其个人资料；
                </p>
                <p>
                    (iii) 具有资料便携性的权利；
                </p>
                <p>
                    (iv) 在某些情况下，撤回他／她以前就处理其个人资料而给予的同意；及
                </p>
                <p>
                    (v) 就处理其个人资料向当地个人资料保护机构提出申诉。
                </p>
                <p>
                    12. 根据私隐条例的规定，凯基(香港)有权就处理任何查阅资料的要求收取合理费用。
                </p>
                <p>
                    13. 如欲要求停止使用资料当事人的个人资料作直接促销用途，查询或更正资料，查询有关政策、惯例及资料的种类，行使上述任何权利或提出申诉，请向以下人士提出：
                </p>
                <p>
                    资料保护专员 凯基(香港)
                </p>
                <p>
                    香港湾仔港湾道十八号中环广场四十一楼
                </p>
                <p>
                    电话：(852) 2878-6888 传真：(852) 2878-4932
                </p>
                <p>
                    14. 凯基(香港)可对本声明不时作出修改、修订或补充。最新版本的声明可於凯基(香港)之网站www.kgi.com.hk 取览或以书面方式向凯基(香港)索取。本声明(以及不时被修改、修订或补充的声明) 的内容适用於所有的资料当事人，并构成不时对有关资料当事人与凯基之间的关係具有约束力的条款及条件的一部分。
                </p>
                <p>
                    15. 在本声明内，凯基證券亚洲有限公司、凯基资产管理有限公司、凯基金融亚洲有限公司、KGI Finance Limited、凯基期货(香港)有限公司、凯基国际金融有限公司、凯基国际(香港)有限公司、凯基投资理财有限公司、凯基代理人(香港)有限公司及KGI Hong Kong Limited共同及个别称为「凯基(香港)」，而凯基(香港)连同彼等各别的控股公司、附属公司、相联公司及关联公司(无论在香港或香港以外)共同及个别称为「凯基證券集团」。所有上文述及的「资料当事人」包括个人，而该个人为任何凯基(香港)公司预期的或现有的客户或对手; 获授权人、受益人、董事、股东、控制人、人员、员工; 凯基(香港)网站的访客; 参与推广活动、比赛、投资者教育活动或遊戏的人士; 及上文第5(vi) 条条款所述之人士。
                </p>
                <p>
                    如中英文版本有任何歧义，概以英文版本为準。
                </p>
                <p>
                    (2201)
                </p>
            </div>
        );
    }
    else if (i18n.language === "EN") {
        return (
            <div>
                <p>
                    This Statement is made by KGI Hong Kong (as defined below) in accordance with the Personal Data (Privacy) Ordinance (Cap. 486 of the Laws of Hong Kong) (“the Ordinance”). The Statement is intended to notify data subjects (as defined below) of why personal data is collected, how it will be used and to whom data access requests are to be addressed.
                </p>
                <p>
                    1. From time to time, it is necessary for data subjects or other relevant persons to supply KGI Hong Kong with personal data of data subjects in connection with the opening or continuation of accounts, the establishment or continuation of trading or credit facilities or provision of financial, securities, commodities, derivatives, futures, options,investment, financing, insurance, MPF/ORSO, wealth management, asset management, investor education programmes/games and related advisory or other services, products and facilities.
                </p>
                <p>
                    2. Failure to supply such data may result in KGI Hong Kong being unable to open or continue accounts or establish or continue trading or credit facilities or provide the services, products or facilities mentioned in Clause 1 above.
                </p>
                <p>
                    3. It is also the case that data are collected from data subjects or other relevant persons in the ordinary course of the continuation of the business relationship or other dealing between data subjects or such relevant persons and KGI Hong Kong. When using KGI Hong Kong’s website, a data subject’s data (including online identifiers) and information on his/her browsing activities are collected and tracked by using cookies and other technologies.
                </p>
                <p>
                    4. The purposes for which data relating to data subjects may be used, and processed (whether within or outside Hong Kong) are as follows:
                </p>
                <p>
                    (i) the daily operation of the services and facilities provided to data subjects;
                </p>
                <p>
                    (ii) conducting credit checks;
                </p>
                <p>
                    (iii) assisting other financial institutions to conduct credit checks;
                </p>
                <p>
                    (iv) ensuring ongoing credit worthiness of data subjects;
                </p>
                <p>
                    (v) designing and conducting survey, statistical and data analysis to enhance and customize the services, products or facilities mentioned in Clause 1 above for data subjects' use;
                </p>
                <p>
                    (vi) marketing the services, products and facilities mentioned in Clause 1 above (details of the use or provision of personal data by KGI Hong Kong for direct marketing purposes are set out in Clause 6 below);
                </p>
                <p>
                    (vii) determining the amount of indebtedness owed to or by data subjects;
                </p>
                <p>
                    (viii) collection of amounts outstanding from data subjects and those providing guarantee or security for data subjects' obligations;
                </p>
                <p>
                    (ix) meeting the requirements to make disclosure under the requirements of any legal and/or regulatory requirements or court orders binding on KGI Hong Kong;
                </p>
                <p>
                    (x) enabling KGI Hong Kong to comply with any applicable laws, rules, regulations, industry practices, legal obligations, or any requirements, requests, codes, guidance or guidelines of any exchanges or any regulatory, tax, law enforcement or government bodies in any jurisdiction to which KGI Hong Kong is subject (such as guidelines issued by the Hong Kong Inland Revenue Department for the implementation of automatic exchange of financial account information (AEOI) and the U.S. Foreign Account Tax Compliance Act (FATCA);
                </p>
                <p>
                    (xi) complying with any obligations, requirements, policies, procedures, guidelines, measures or arrangements for sharing data and information within KGI Group and/or any other use of data and information in accordance with any programmes for sanctions, prevention or detection of money laundering, terrorist financing, tax evasion or other unlawful activities; and
                </p>
                <p>
                    (xii) purposes relating to any of the above.
                </p>
                <p>
                    5. Data held by KGI Hong Kong relating to a data subject will be kept confidential but KGI Hong Kong may provide such data to the following parties (whether within or outside Hong Kong):
                </p>
                <p>
                    (i) any agent, contractor or third party service provider who provides administrative, telecommunications, computer, financial, trade execution, cash, securities and/or contracts clearing or settlement or other services to KGI Hong Kong in connection with the operation of its business;
                </p>
                <p>
                    (ii) any other person under a duty of confidentiality to KGI Hong Kong including but not limited to any member of the KGI Group which has undertaken to keep such information confidential;
                </p>
                <p>
                    (iii) any financial institution or dealer with which the data subject has or proposes to have dealings;
                </p>
                <p>
                    (iv) any credit reference agency and in the event of default, any debt collection agency;
                </p>
                <p>
                    (v) any actual or proposed assignee of KGI Hong Kong or participant or sub-participant or transferee of KGI Hong Kong's rights in respect of the data subjects;
                </p>
                <p>
                    (vi) any person providing or proposing to provide guarantee or security for a data subject’s obligations; and
                </p>
                <p>
                    (vii) any exchange, entity, agency or any regulatory, tax, law enforcement or government body in any jurisdiction (whether for the performance of its regulatory, surveillance and/or enforcement function or otherwise) if required by law or pursuant to any court orders, rules, regulations, legal obligations, requirements, requests, codes, guidance or guidelines to which KGI Hong Kong is subject. In such cases, KGI Hong Kong is usually under a duty of secrecy and will not be able to notify a data subject or seek his/her consent in relation to such release of information.
                </p>
                <p>
                    6. USE OF DATA IN DIRECT MARKETING
                </p>
                <p>
                    KGI Hong Kong intends to use but will only use a data subject’s personal data in direct marketing with the data subject’s consent (which includes an indication of no objection) for that purpose. In this connection, please note that:
                </p>
                <p>
                    (i) the data subject’s personal data such as the data subject’s name, telephone number, email address, correspondence address, account number, online identifiers, products and services portfolio information, transaction pattern and behaviour, risk profile, financial background and investment objectives and experience may be used by KGI Hong Kong in direct marketing;
                </p>
                <p>
                    (ii) the following classes of services, products, facilities and marketing subjects may be marketed:
                </p>
                <p>
                    (1) financial, securities, commodities, derivatives, futures, options, investment, financing, insurance, MPF/ORSO, wealth management, asset management, investor education programmes/games and related advisory or other services, products and facilities;
                </p>
                <p>
                    (2) reward, loyalty or privileges programmes and related services, products and facilities;
                </p>
                <p>
                    (3) services, products and facilities offered by business partners of any member of KGI Group providing any of the services, products and facilities referred to in Clause 6(ii)(1) above; and
                </p>
                <p>
                    (4) donations and contributions for charitable and/or non-profit making purposes;
                </p>
                <p>
                    (iii) the above services, products, facilities and marketing subjects may be provided or (in the case of donations and contributions) solicited by KGI Hong Kong and/or any of the following persons:
                </p>
                <p>
                    (1) any member of the KGI Group;
                </p>
                <p>
                    (2) third party financial institutions and providers of any of the services, products and facilities referred to in Clause 6(ii)(1) above;
                </p>
                <p>
                    (3) third party reward, loyalty, co-branding or privileges programme providers;
                </p>
                <p>
                    (4) business partners of any member of KGI Group providing any of the services, products and facilities referred to in Clause 6(ii)(1) above; and
                </p>
                <p>
                    (5) charitable or non-profit making organisations;
                </p>
                <p>
                    (iv) KGI Hong Kong intends to provide but will only provide the personal data described in Clause 6(i) above to any of the persons referred to in Clause 6(iii) above for use by any of them in direct marketing of the services, products, facilities and marketing subjects referred to in Clause 6(ii) above with the data subject’s written consent (which includes an indication of no objection). KGI Hong Kong may so provide the personal data to such persons for direct marketing purposes for gain (whether in the form of any fee, commission, benefit or otherwise).
                </p>
                <p>
                    If a data subject wishes KGI Hong Kong to cease to use his/her personal data and/or provide it to other persons for use in direct marketing, the data subject may notify KGI Hong Kong in writing by mailing or faxing the written notification to the postal address or fax number provided in Clause 13 below. KGI Hong Kong shall then cease to use and/or provide his/her personal data for direct marketing purposes without any charge.
                </p>
                <p>
                    7. Data subjects agree that KGI Hong Kong may from time to time transfer data subjects’ personal data outside Hong Kong for any of the purposes stated in Clauses 1 to 6 above. Furthermore, personal data may be transferred to countries located outside the European Union (EEA) which do not provide a similar level of protection to that provided by countries in the EEA. KGI Hong Kong will take reasonably necessary steps to ensure that personal data are treated with adequate level of protection and in accordance with this Statement.
                </p>
                <p>
                    8. Where you provide personal data of other data subjects to KGI Hong Kong, you undertake and represent that you have notified and obtained necessary consents from such data subjects for the collection, use and processing of such data subjects’ personal data by KGI Hong Kong in accordance with this Statement, and in so notifying and obtaining the necessary consents from such data subjects, you shall fully comply with all applicable personal data protection laws of relevant jurisdictions including but not limited to the Ordinance. You agree to provide KGI Hong Kong with evidence of such consents promptly as and when requested by KGI Hong Kong.
                </p>
                <p>
                    9. There may be instances where data subjects elect to provide personal information to KGI Hong Kong through electronic means (such as Internet or voice recording system). Whilst KGI Hong Kong generally uses best endeavours to maintain the security and integrity of its systems, due to many unpredictable traffic or other reasons, electronic communication may not be a reliable medium of communication. Data subjects should take heed of such weaknesses and communicate personal information through electronic devices with caution.
                </p>
                <p>
                    10. KGI Hong Kong retains personal data for only so long as it is necessary for the fulfillment of the purposes for which the data are used as stated in this Statement or longer if required by any legal or regulatory requirement or as is otherwise necessary.
                </p>
                <p>
                    11. Under and in accordance with the terms of the Ordinance, an individual has the right to:
                </p>
                <p>
                    (i) check whether KGI Hong Kong holds data about him/her and the right of access to such data;
                </p>
                <p>
                    (ii) require KGI Hong Kong to correct any data relating to him/her which is inaccurate; and
                </p>
                <p>
                    (iii) as certain KGI Hong Kong's policies and practices in relation to data and to be informed of the kind of personal data held by KGI Hong Kong.
                </p>
                <p>
                    If an individual is in a member state of the European Union (EU), subject to certain limitations and/or restrictions, the General Data Protection Regulation (GDPR) may be applicable to the individual and the individual has the right under GDPR to:
                </p>
                <p>
                    (i) request access to and rectification or erasure of his/her personal data;
                </p>
                <p>
                    (ii) obtain restriction of processing or to object to processing of his/her personal data;
                </p>
                <p>
                    (iii) the right to data portability;
                </p>
                <p>
                    (iv) withdraw the consents that he/she has given for the processing of his/her personal data in certain circumstances; and
                </p>
                <p>
                    (v) lodge a complaint about the processing of his/her personal data with his/her local data protection authority.
                </p>
                <p>
                    12. In accordance with the terms of the Ordinance, KGI Hong Kong has the right to charge a reasonable fee for the processing of any data access request.
                </p>
                <p>
                    13. The person to whom requests for ceasing to use of personal data in direct marketing, access to data, correction of data or information regarding policies and practices and kinds of data held, exercising any of the above rights or raising complaints are to be addressed as follows:
                </p>
                <p>
                    The Data Protection Officer, KGI Hong Kong
                </p>
                <p>
                    41/F, Central Plaza, 18 Harbour Road, Wanchai, Hong Kong
                </p>
                <p>
                    Tel : (852) 2878 6888 Fax : (852) 2878 4932
                </p>
                <p>
                    14. This Statement may be revised, amended or supplemented from time to time by KGI Hong Kong. The most up-to-date statement can be found in KGI Hong Kong's website at www.kgi.com.hk or available from KGI Hong Kong upon written request. The contents of this Statement (as revised, amended and supplemented from time to time) shall apply to all data subjects and form part of any terms and conditions governing the relationship between KGI Hong Kong and the data subjects concerned from time to time.
                </p>
                <p>
                    15. In this Statement, all references to “KGI Hong Kong” refer to KGI Asia Limited, KGI Asset Management Limited, KGI Capital Asia Limited, KGI Finance Limited, KGI Futures (Hong Kong) Limited, KGI International Finance Limited, KGI International (Hong Kong) Limited, KGI Investments Management Limited, KGI Nominees (Hong Kong) Limited and KGI Hong Kong Limited collectively or individually and all references to “KGI Group” refer to KGI Hong Kong together with their respective holding companies, subsidiary companies, associated companies and affiliated companies collectively or individually whether in or outside of Hong Kong. All references to “data subjects” include individuals who are prospective or existing customers or counterparties of any KGI Hong Kong company; authorized signatories, beneficial owners, directors, shareholders, controllers, officers, staff members; visitors to KGI Hong Kong’s website; individuals who participate in promotion, contest, investor education programme or game; and persons referred to in Clause 5(vi) above.
                </p>
                <p>
                    If there is any inconsistency between the Chinese and the English versions, the English version shall prevail.
                </p>
                <p>
                    (2201)
                </p>
            </div>
        );
    }
}
  
export default DataPrivacyContent;
